<app-dialog (actionButtonClicked)="onFormSubmit($event)" [config]="data.config">
    <ng-container dialog-title>Add Route</ng-container>

    <ng-container *ngIf="form && form.formGroup" dialog-process-in-progress>
        <form [formGroup]="form.formGroup" class="row add-exchange-form">
            <div [ngClass]="{'mb-3': form.controls.broker.errors?.length > 0}" [ngClass]="{ 'hidden': hideBroker }" class="col-12">
                <app-select [control]="form.controls.broker" [formControlName]="form.controls.broker.name"></app-select>
            </div>
            <div [ngClass]="{'mb-3': form.controls.displayName.errors?.length > 0}" class="col-12">
                <app-panel-input [control]="form.controls.displayName" [formControlName]="form.controls.displayName.name"></app-panel-input>
            </div>
            <div [ngClass]="{'mb-3': form.controls.subDestination.errors?.length > 0}" class="col-12">
                <app-panel-input [control]="form.controls.subDestination" [formControlName]="form.controls.subDestination.name"></app-panel-input>
            </div>
        </form>
    </ng-container>
</app-dialog>
